import { useEffect, useState } from "react";

/** Current time, refreshed every `intervalMs` so countdowns stay live. Pass
 *  `enabled = false` when nothing on screen reads it, so it never re-renders. */
export const useNow = (
  intervalMs: number = 60 * 1000,
  enabled: boolean = true,
): Date => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    if (!enabled) return;
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, enabled]);
  return now;
};
